import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { EntityProps, EntityState } from '@ngrx/signals/entities';

import { Caractéristique } from '../models/caractéristique.model';

export function avecSélecteursCaractéristiques<_>() {
  return signalStoreFeature(
    {
      state: type<EntityState<Caractéristique>>(),
      props: type<EntityProps<Caractéristique>>(),
    },
    withComputed(({ entities }) => ({
      caracteristiques: computed(() => entities().filter((x) => !x.idCaracteristiqueParente)),
    })),
  );
}
